import { useLazyQuery, useQuery } from '@apollo/client'
import { useEffect } from 'react'

import { CHANNELS_QUERY } from '../../graphql/channel'
import { USERS_LIST_QUERY } from '../../graphql/userManagement'
import { Channel } from '../../types/channel'
import { UserBrief, UserList } from '../../types/users'
import ChannelFilters from './ChannelFilters'
import ChannelList from './ChannelList'

interface ChannelSectionProps {
  setUsers: React.Dispatch<React.SetStateAction<UserBrief[]>>
  users: UserBrief[]
  autoCompleteChannelsList: any
  setAutoCompleteChannelsList: React.Dispatch<any>
}

const ChannelSection: React.FC<ChannelSectionProps> = ({
  setUsers,
  users,
  autoCompleteChannelsList,
  setAutoCompleteChannelsList
}) => {
  const { data, loading } = useQuery<{
    channels: Channel[]
  }>(CHANNELS_QUERY)

  const [getUserList, { data: usersData }] = useLazyQuery<{
    users: UserList
  }>(USERS_LIST_QUERY, {
    notifyOnNetworkStatusChange: true,
    onCompleted: (res) => {
      setUsers(res.users.users)
    }
  })

  useEffect(() => {
    const channelCodes = autoCompleteChannelsList?.map((ele: any) => ele.code)

    if (channelCodes && channelCodes.length > 0) {
      getUserList({
        variables: {
          filters: { entityCodes: channelCodes }
        }
      })
    }
  }, [autoCompleteChannelsList])

  return (
    <div>
      <ChannelFilters
        channels={data?.channels}
        loading={loading}
        autoCompleteChannelsList={autoCompleteChannelsList}
        setAutoCompleteChannelsList={setAutoCompleteChannelsList}
      />
      {autoCompleteChannelsList && autoCompleteChannelsList.length > 0 && (
        <ChannelList
          channels={data?.channels}
          usersData={usersData?.users.users}
          autoCompleteChannelsList={autoCompleteChannelsList}
          setUsers={setUsers}
          users={users}
        />
      )}
    </div>
  )
}

export default ChannelSection
